export const GET_USER = "GET_USER"
export const LOGOUT_USER = "LOGOUT_USER"
export const LOGIN_USER = 'LOGIN_USER'
export const GET_NORM_USER_ABOUT = 'GET_NORM_USER_ABOUT'
export const GET_DOCTOR_ABOUT = 'GET_DOCTOR_ABOUT'
export const UPDATE_NORM_USER_ABOUT = "UPDATE_NORM_USER_ABOUT"
export const UPDATE_DOCTOR_ABOUT = "UPDATE_DOCTOR_ABOUT"

export const CHANGE_MADE = "CHANGE_MADE"
export const  GET_USER_LOADING = "GET_USER_LOADING"
export const LOGIN_USER_LOADING='LOGIN_USER_LOADING'



